/** Max length for the message field on the team trial upgrade request modal. */
export const TEAM_TRIAL_UPGRADE_REQUEST_MESSAGE_MAX_LENGTH = 1000;
